import Stack from "@mui/material/Stack";

import useVariant from "hooks/useVariant";
import useUpdateVariant from "hooks/useUpdateVariant";
import useVariantsFilter from "hooks/useVariantsFilter";
import useGtagVariantData from "hooks/useGtagVariantData";
import useDistinctVariantTypes from "hooks/useDistinctVariantTypes";
import ToggleButton from "./ToggleButton";

const batterySorter = (a: string, b: string) => parseInt(b) - parseInt(a);

export default function BatterySelector() {
  const variant = useVariant();
  const filteredVariants = useVariantsFilter({ code: variant?.code, variant: variant?.variant });
  const batteries = useDistinctVariantTypes("battery", filteredVariants, batterySorter);
  const updateVariant = useUpdateVariant();
  const getGtagData = useGtagVariantData();

  const selectedBattery = batteries.find(({ selected }) => selected);

  const handleChange = (newValue: string) => {
    if (selectedBattery?.code === newValue) return;

    updateVariant({ battery: newValue }, filteredVariants);
    window.gtag(
      "event",
      "variant_change",
      getGtagData("model", `Change variant (Battery) to ${newValue}`),
    );
  };

  return (
    <Stack mt={1.5} mb={0.5} direction="row" columnGap={2} rowGap={2} width="100%" flexWrap="wrap">
      {batteries.map((value) => (
        <ToggleButton
          key={value.code}
          selected={value.code === selectedBattery?.code}
          ButtonProps={{ onClick: () => handleChange(value.code) }}
        >
          {parseInt(value.code)}
        </ToggleButton>
      ))}
    </Stack>
  );
}
